import React from 'react';
import {
    extractGroundingFields,
    formatCitationCoveragePercent,
    formatGroundingStatusLabel,
    groundingDisplayTone,
} from '../../../utils/intelligenceMeta';
import styles from '../css/index.module.css';

const TONE_CLASS = {
    success: styles.aiWardenTrustStripSuccess,
    warning: styles.aiWardenTrustStripWarning,
    danger: styles.aiWardenTrustStripDanger,
    neutral: styles.aiWardenTrustStripNeutral,
};

const GroundingBadge = ({ evidenceGovernance, retrievalDebug }) => {
    const fields = extractGroundingFields(evidenceGovernance, retrievalDebug);
    if (!fields.grounding_status && fields.citation_coverage == null && !fields.hallucination_risk_flag) {
        return null;
    }

    const tone = groundingDisplayTone(fields);
    const coverage = formatCitationCoveragePercent(fields.citation_coverage);

    return (
        <div className={`${styles.aiWardenTrustStrip} ${TONE_CLASS[tone] || TONE_CLASS.neutral}`} role="status" aria-label="Answer grounding">
            <span className={styles.aiWardenTrustStripLabel}>{formatGroundingStatusLabel(fields.grounding_status)}</span>
            {coverage != null && <span className={styles.aiWardenTrustStripMeta}>Citations: {coverage} coverage</span>}
        </div>
    );
};

export default GroundingBadge;
